/**
 * Bề rộng các cột của bảng xếp hạng giải — MỘT nguồn duy nhất cho hàng tiêu đề
 * (`pages/league/league.tsx`) và hàng dữ liệu (`components/league/CompetitorCard.tsx`).
 *
 * Trước đây hai nơi tự khai số riêng và lệch số ô: tiêu đề 4 ô
 * (# 20 / Cơ thủ 50 / Hạng 10 / Đối đầu 20) còn hàng dữ liệu 5 ô
 * (20 / 50 / 10 / 10 / 10). Sửa một bên là lệch bên kia, nên gom về đây.
 *
 * Cột `nut` ở hàng tiêu đề là ô trống giữ chỗ cho nút mở rộng của hàng dữ liệu:
 * nhờ nó hai bên cùng 5 ô. Nhãn "Đối đầu" vẫn bắt đầu ở mốc 80% y như trước nên
 * không có thay đổi nhìn thấy được.
 */
export const COT_BXH = {
  /** Giải đã bắt đầu: có số thứ tự, hạng, đối đầu và nút mở rộng. */
  dayDu: {
    rank: "w-[20%]",
    ten: "w-[50%]",
    hang: "w-[10%]",
    doiDau: "w-[10%]",
    nut: "w-[10%]",
  },
  /** Giải chưa bắt đầu (`hideCountMatch`): bỏ số thứ tự và nút, ô tên rộng ra. */
  chuaBatDau: {
    ten: "w-[70%]",
    hang: "w-[10%]",
    doiDau: "w-[10%]",
  },
} as const;
